import React, { useState, useEffect, Fragment, forwardRef } from 'react';
import { Row, Label, Col, Button, Input, Form, FormGroup, Card } from "reactstrap";
import axios from 'axios';
import { useForm } from 'react-hook-form';
import Dropzone from 'react-dropzone-uploader';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { mykyc, setDealerGstnVerify } from '../../../../../redux/kyc/action';
import validateFile from '../../../../../utilities/validateFile';
import handleupload from '../../../../../utilities/handleUpload';
import PDFViewer from '../../../../../utilities/PDFViewer';
import { Edit, InfoOutlined } from '@mui/icons-material';
import FileUploadComponent from '../../../../common/FileUpload';
import RequiredIndicator from '../../../../partial/RequiredIndicator';
import KycViewNote from '../../kyc_note/KycViewNote';
import KycEditNote from '../../kyc_note/KycEditNote';
import { stateCityByPincode, updateDealer, validateGstnNumber } from '../../../../../api';
import { getFromLocalStorage } from '../../../../../hooks/useLocalStorage';
import kycSpecialCharacterConstrains from '../../../../../utilities/kycSpecialCharacterConstrains';
import { verifyButton } from '../../../../../constant';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const Gstn = (props, ref) => {

    const { activeStep, setActiveStep, setStep2Valid, dealerKycData, is_kyc_submitted, is_kyc_active, setIsUpdated, dealershipData } = props;

    const { handleSubmit, register, setValue, trigger, getValues, errors, setError } = useForm();
    const [loading, setLoading] = useState(false);
    const [pinCode, setPinCode] = useState('');
    const [dealerName, setDealerName] = useState('');
    const [gstinAccName, setGstinAccName] = useState('');
    const [defaultEntityType, setDefaultEntityType] = useState('');
    const [gstnState, setGstnState] = useState('');
    const [gstnStateCode, setGstnStateCode] = useState("");
    const kycData = useSelector((content) => content.Kyc);
    const [gstnEditable, setGstnEditable] = useState(kycData?.gstn?.gstn_number_last_three_digit ? kycData?.gstn?.gstn_number_last_three_digit : kycData?.gstn?.gstn_number?.length > 13 ? kycData?.gstn?.gstn_number.slice(-3) : "");

    // const [gstnNo, setGstnNo] = useState(gstnStateCode + kycData?.panCard?.dealer_pan_card_number);
    const [gstUrl, setGstUrl] = useState("");
    const dispatch = useDispatch();

    const [isgstnVerify, setIsGstnVerify] = useState(false);
    const [isGstnVerification, setIsGstnVerification] = useState(false);
    const [panVerifiedDealerName, setPanVerifiedDealerName] = useState("");
    const [isGstnEntityType, setIsGstnEntityType] = useState("");
    const [isGstnTradeName, setIsGstnTradeName] = useState("");

    const fetchPincodeDetails = async (pincode) => {
        try {

            const res = await stateCityByPincode(pincode);
            const pincodeData = res.data?.result;

            if (pincodeData && pincodeData?.stateSchema?.state_gst_code) {
                setGstnStateCode(pincodeData?.stateSchema?.state_gst_code)
            }
        } catch (err) {
            toast.error("err in fetch pincode details")

        }
    };

    useEffect(() => {
        // setGstnNo(gstnStateCode + kycData?.panCard?.dealer_pan_card_number);
        const user = JSON.parse(localStorage.getItem("user"));
        const pin_code = user?.dealerInfo?.pin_code;
        const gstnDealerState = user?.dealerInfo?.state;
        const dealer_name = user?.dealerInfo?.dealer_name;
        const gstnEntityType = localStorage.getItem("gstnEntityType");
        const gstnTradeName = localStorage.getItem("gstnTradeName");

        setPinCode(pin_code);
        setGstnState(gstnDealerState);
        fetchPincodeDetails(pin_code);
        setDealerName(dealer_name);
        setIsGstnEntityType(gstnEntityType);
        setIsGstnTradeName(gstnTradeName);
        setGstinAccName(kycData.panCard?.dealer_pan_card_name);

        async function checkDetails() {
            const storedData = kycData.gstn;
            Object.keys(storedData).forEach((fieldName) => {
                setValue(fieldName, storedData[fieldName]);
            });
            setValue('gstn_state', gstnDealerState);
            setValue('gstn_pincode', pin_code);
            //setIsGstnEntityType(storedData?.entity_type);
            setGstUrl(getValues()["gstn_image"])
        }
        checkDetails()
    }, [kycData.panCard?.dealer_pan_card_number, kycData.panCard?.dealer_pan_card_name]);

    const submitForm = (data) => {
        if (!kycData?.gstn?.gstnVerify){
            toast.error('GSTIN not verified');
            return;
        }
        setLoading(true);
        const gstn_number = data.gstn_state_code + kycData?.panCard?.dealer_pan_card_number + data.gstn_number_last_three_digit;
        dispatch(mykyc({ ...kycData, gstn: { ...kycData.gstn, ...data, gstn_number: gstn_number, trade_name: isGstnTradeName}, txnid: Date.now() }));
        setIsUpdated(true)
        setTimeout(() => {
            setIsUpdated(false)
        }, 2000);
        if (activeStep === 1) {
            setLoading(false);
            setStep2Valid(true);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    //Uncomment this for Tax API
    // const submitForm = (data) => {
    //     if(!kycData?.gstn?.gstnVerify){
    //         toast.error('GSTIN not verified');
    //         return;
    //     }
    //     setLoading(true);
    //     const gstn_number = data.gstn_state_code + kycData?.panCard?.dealer_pan_card_number + data.gstn_number_last_three_digit;
    //     dispatch(mykyc({ ...kycData, gstn: { ...kycData.gstn, ...data, gstn_number: gstn_number }, txnid: Date.now() }));
    //     setIsUpdated(true)
    //     setTimeout(() => {
    //         setIsUpdated(false)
    //     }, 2000);
    //     if (activeStep === 1) {
    //         setLoading(false);
    //         setStep2Valid(true);
    //         setActiveStep((prevActiveStep) => prevActiveStep + 1);

    //     }
    // };

    const verifyGstnDetails = async (data) => {
        console.log(data, "gstn data111111"); 
        setIsGstnVerification(false);
        const dealer_name = dealershipData?.dealer_name;
        const dealership_id = dealershipData?.dealership_id;
        const dealer_gstn_number = data;
        setIsGstnVerify(true);
        try {
            const gstnPayload = { gstNumber: dealer_gstn_number }

            const gstnVerifiedRes = await validateGstnNumber(gstnPayload);
            // console.log("gstnVerifiedRes : ", gstnVerifiedRes);

            console.log("isGstnTradeName : ", isGstnTradeName);
            
            if (gstnVerifiedRes?.status == 200) {
                const gstn_verification_status = gstnVerifiedRes?.data?.result?.msg?.basicDetails?.registrationStatus;
                const gstn_entity_type = gstnVerifiedRes?.data?.result?.msg?.basicDetails?.constitutionOfBusiness;
                const gstn_trade_name = gstnVerifiedRes?.data?.result?.msg?.basicDetails?.tradeName;
                const gstn_legal_business_name = gstnVerifiedRes?.data?.result?.msg?.basicDetails?.legalBusinessName;

                console.log("gstn_trade_name : ", gstn_trade_name); 
                console.log("gstn_legal_business_name : ", gstn_legal_business_name);

                if(gstn_trade_name == "" || gstn_trade_name == "NA") {
                    localStorage.setItem("gstnTradeName", gstn_legal_business_name);
                    setIsGstnTradeName(gstn_legal_business_name);
                } else {
                    localStorage.setItem("gstnTradeName", gstn_trade_name);
                    setIsGstnTradeName(gstn_trade_name);
                }
                
                Swal.fire({
                    icon: 'info',
                    // title: '',
                    html: `Verification status of the provided GSTIN(<b>${dealer_gstn_number}</b>) is <b>${gstn_verification_status}</b>.`,
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                })
                    
                setIsGstnVerification(true);
                localStorage.setItem("gstnEntityType", gstn_entity_type);
                setIsGstnEntityType(gstn_entity_type);

                dispatch(setDealerGstnVerify(true));

            } else {
                return false
            }
        } catch (error) {
            toast.error(error?.response?.data?.error ? error?.response?.data?.error : 'Something went wrong');
            setIsGstnVerify(false);
            return;
        }
        setIsUpdated(true)
        setTimeout(() => {
            setIsUpdated(false)
        }, 2000);

    };

    const gstPattern = /^([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-8]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/gi

    const handleBack = () => {
        if (is_kyc_submitted) {
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        } else {
            const rhfdata = getValues()
            dispatch(mykyc({ ...kycData, gstn: rhfdata, txnid: Date.now() }));
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
        }
    };

    const onSubmitForKycSubmitComplete = () => {
        if (activeStep === 1) {
            setStep2Valid(true);
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    }

    return (
        <Fragment>
            <Row>
                <Col xl="12" md="12" sm="12" className="mt-4" key={1}>
                    <div className="project-box">
                        {is_kyc_active ? (<span className={`badge badge-success`}>{"Verified"}</span>) : ''}
                        <div className='mt-3'>
                            {(is_kyc_submitted || is_kyc_active) ? (
                                <>
                                    <Row>
                                        <Col xl="6" md="6">
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"State"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstn_state"
                                                            type="text"
                                                            defaultValue={kycData?.gstn?.gstn_state}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Pincode"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstn_pincode"
                                                            type="text"
                                                            defaultValue={kycData?.gstn?.gstn_pincode}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Entity Type"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="entity_type"
                                                            type="text"
                                                            defaultValue={kycData?.gstn?.entity_type}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"GSTN No."}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstn_number"
                                                            type="text"
                                                            defaultValue={kycData?.gstn?.gstn_number}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Name in the Account"}</Label>
                                                        <Input
                                                            className="form-control"
                                                            name="gstn_account_name"
                                                            type="text"
                                                            defaultValue={kycData?.gstn?.gstn_account_name}
                                                            readOnly
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <KycViewNote />
                                        </Col>
                                        <Col xl="6" md="6" className="d-flex justify-content-center">
                                            <FormGroup className='text-center'>
                                                <Label>{"GSTN document"}</Label>
                                                <FileUploadComponent name="gstn_image" fileUploadFlag={false} data={kycData?.gstn?.gstn_image} viewOnly={true} />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-between">
                                        <Col md="auto">
                                            {activeStep !== 0 && (
                                                <Button
                                                    color="info"
                                                    disabled={activeStep === 0}
                                                    onClick={handleBack}
                                                >
                                                    Back
                                                </Button>
                                            )}
                                        </Col>
                                        <Col md="auto">
                                            <Button type="submit" color="info" onClick={onSubmitForKycSubmitComplete}>
                                                Next
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            ) : getFromLocalStorage("ROLE")?.key == "DEALERSHIP_MANAGER" && (
                                <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(submitForm)} >
                                    <Row>
                                        <Col xl="6" md="6">
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"State"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="gstn_state"
                                                            type="text"
                                                            innerRef={register({ required: true })}
                                                            value={gstnState}
                                                            readOnly
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {errors.gstn_state && "State is required"}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Pincode"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="gstn_pincode"
                                                            type="text"
                                                            innerRef={register(kycSpecialCharacterConstrains(true, "PIN Code is required"))}
                                                            value={pinCode}
                                                            readOnly
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {errors.gstn_pincode?.message}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {/* <Col xl="12" md="12"> */}
                                                <Col xl="9" md="9">
                                                    <FormGroup>
                                                        <Label>{"GSTN No."}</Label> <RequiredIndicator />
                                                        <Row style={{ display: 'flex', alignItems: 'center', marginLeft: 0 }}>
                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                name="gstn_state_code"
                                                                value={gstnStateCode}
                                                                innerRef={register(kycSpecialCharacterConstrains(true, 'GST State Code is required'))}
                                                                style={{ width: '15%' }}
                                                                readOnly
                                                            />
                                                            <Input
                                                                className="form-control"
                                                                type="text"
                                                                value={kycData?.panCard?.dealer_pan_card_number}
                                                                style={{ width: '50%', marginLeft: 10 }}
                                                                readOnly
                                                            />
                                                            <Input
                                                                className="form-control"
                                                                name="gstn_number_last_three_digit"
                                                                type="text"
                                                                maxLength={3}
                                                                innerRef={register({
                                                                    required: 'GST Number is required', pattern: { value: /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]*$/, message: 'GST Number must be alphanumeric and at least 3 characters long' }, minLength: { value: 3, message: 'GST Number must be at least 3 characters long' },
                                                                })}
                                                                // onKeyPress={(event) => {
                                                                //     // if (!/^[a-zA-Z0-9]{3,}$/.test(event.key)) {
                                                                //     //     event.preventDefault();
                                                                //     // }
                                                                //     if (event.target.value.length >= 3) {
                                                                //         event.preventDefault();
                                                                //     }
                                                                // }}
                                                                // value={getValues()["gstn_number_last_three_digit"]? getValues()["gstn_number_last_three_digit"] : kycData?.gstn?.gstn_number?.slice(-3)}
                                                                value={getValues()["gstn_number_last_three_digit"] ? getValues()["gstn_number_last_three_digit"] : gstnEditable}
                                                                onChange={(e) => {
                                                                    setGstnEditable(e.target.value)
                                                                    setValue("gstn_number_last_three_digit", e.target.value)
                                                                    trigger("gstn_number_last_three_digit")
                                                                }}
                                                                style={{ width: '27%', marginLeft: 10 }}
                                                                readOnly={kycData?.gstn?.gstnVerify ? true : false}
                                                            />
                                                        </Row>
                                                        <span style={{ color: "red" }}>
                                                            {errors?.gstn_number_last_three_digit && errors?.gstn_number_last_three_digit?.message}
                                                            {errors?.gstn_state_code && errors?.gstn_state_code?.message}
                                                            {/* {errors.gstn_number_last_three_digit && errors.gstn_number_last_three_digit.type === "pattern" && <span>GST Number is not valid</span>}
                                                            {errors.gstn_number_last_three_digit && errors.gstn_number_last_three_digit.type === "minLength" && <span>GST Number length must be 3 digit</span>} */}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                                <Col xl="3" md="3" className="verify-button">
                                                    {kycData?.gstn?.gstnVerify ?
                                                        <Button color="success" className="verify-gst-button" disabled>
                                                            <FontAwesomeIcon icon={faCheck} />
                                                        </Button>
                                                        :
                                                    <Button color="info"
                                                        className="verify-gst-button"
                                                        onClick={() => {
                                                            const gstnNumberLastThreeDigit = getValues()["gstn_number_last_three_digit"];
                                                            if (!gstnNumberLastThreeDigit) {
                                                                toast.error("Please enter GSTIN number");
                                                                return;
                                                            }
                                                            verifyGstnDetails(`${gstnStateCode}${kycData?.panCard?.dealer_pan_card_number}${getValues()["gstn_number_last_three_digit"]}`);
                                                        }} disabled={isgstnVerify}> {verifyButton} </Button>
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Entity Type"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            type="text"
                                                            value={isGstnEntityType}
                                                            readOnly
                                                            // onChange={async (e) => {
                                                            //     setDefaultEntityType(e.target.value);
                                                            //     await setValue("entity_type", e.target.value);
                                                            //     await trigger("entity_type");
                                                            // }}
                                                            // {...register("entity_type", {
                                                            //     required: true
                                                            // })}
                                                        />
                                                            {/* <option value="" disabled>
                                                                {"Select Entity Type"}
                                                            </option>
                                                            <option value="Proprietary">
                                                                {"Proprietary"}
                                                            </option>
                                                            <option value="Partnership">
                                                                {"Partnership"}
                                                            </option>
                                                            <option value="Limited Company">
                                                                {"Limited Company"}
                                                            </option>
                                                            <option value="Private Limited company">
                                                                {"Private Limited company"}
                                                            </option> */}
                                                        <span style={{ color: "red" }}>
                                                            {errors.entity_type && "Entity is required"}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xl="12" md="12">
                                                    <FormGroup>
                                                        <Label>{"Name in the Account"}</Label> <RequiredIndicator />
                                                        <Input
                                                            className="form-control"
                                                            name="gstn_account_name"
                                                            type="text"
                                                            innerRef={register(kycSpecialCharacterConstrains(true, "Name in the Account is required"))}
                                                            // defaultValue={getValues()["gstn_account_name"]}
                                                            // value={gstinAccName}
                                                            value={isGstnTradeName}
                                                            readOnly
                                                        />
                                                        <span style={{ color: "red" }}>
                                                            {errors?.gstn_account_name && "Name in the Account is required"}
                                                        </span>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <KycEditNote />
                                        </Col>
                                        <Col xl="6" md="6" className="d-flex justify-content-center">
                                            <FormGroup style={{ textAlign: 'center' }}>
                                                <Label>{"Upload GSTN document"}</Label> <RequiredIndicator />
                                                <FileUploadComponent
                                                    register={register}
                                                    name="gstn_image"
                                                    setValue={setValue}
                                                    trigger={trigger}
                                                    getValues={getValues}
                                                    data={gstUrl}
                                                    add={getValues()["gstn_image"]?.length > 0 ? false : true}
                                                    pdfImageOnly={true}
                                                />
                                                <span style={{ color: "red" }}>
                                                    {errors.gstn_image && "GST Document is Required"}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    <Row className="justify-content-between">
                                        <Col md="auto">
                                            {activeStep !== 0 && (
                                                <Button
                                                    color="info"
                                                    disabled={activeStep === 0}
                                                    onClick={handleBack}
                                                >
                                                    &lt;&lt; Back
                                                </Button>
                                            )}
                                        </Col>
                                        <Col md="auto">
                                            <Button type="submit" color="info">
                                                {loading ? "Loading..." : "Save"} <span>&gt;&gt;</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            )}
                        </div>

                    </div>
                </Col>

            </Row>
        </Fragment>
    )
};

export default Gstn;
